import React from 'react';
import styled from 'styled-components';
import {NoRisksRelated, RelatedRisks} from './AccountsRisksCellRenderer';
import {labels} from '../../../../../../../util/utils';
import {
	documentTypes,
	assertionsFormat,
	inherentRiskTypeId as inherentRiskTypes
} from '../../../../../../../util/uiconstants';
import AccountName from './AccountName';
import {lightColor} from '@ey/styled-theme';
import Assertion from '../../../../../../Common/Assertions/Assertion';

export default function AccountsAssertionCellRenderer(params) {
	const data = params.data;
	const value = params.getValue();

	let relatedDocuments = [];
	if (data && data.relatedDocuments && data.relatedDocuments.length > 0) {
		relatedDocuments = data.relatedDocuments.filter((doc) => doc.documentTypeID !== documentTypes.ACCOUNT_CONCLUSION);
	}

	let depth = 0;
	if (data && data.path) {
		depth = data.path.length;
	}

	const accountRow = depth === 1 && (
		<AccountName
			accountId={data?.id}
			createDocIfNotExist
			relatedDocuments={relatedDocuments}
			name={value?.split('|')[1]}
			hasEstimate={data?.hasEstimate}
			executionTypeId={data?.executionTypeId}
		/>
	);

	return accountRow ? (
		accountRow
	) : depth === 2 ? (
		<RelatedAssertions assertion={data?.assertion} />
	) : value === 'NO_RISKS_ASSOCIATED' ? (
		<NoRisksRelated value={labels.noRisksRelatedToAssertion} />
	) : (
		<RelatedRisks risk={data} value={value} fromAssertion />
	);
}

export function RelatedAssertions({assertion}) {
	const inherentRiskTypeId = assertion?.inherentRiskTypeId;
	const foundAssertion = assertionsFormat.find((as) => as.id === assertion?.knowledgeAssertionId);
	let assertionabbreviation, assertionname;
	if (foundAssertion) {
		assertionabbreviation = foundAssertion.assertionabbreviation;
		assertionname = foundAssertion.assertionname;
	}

	return (
		<StyledRelatedAssertions className="StyledRelatedAssertions">
			<section className="AssertionNameLabelWrapper">
				{!!assertion ? (
					<Assertion assertion={assertion} showName displayName={assertionname} inherentRiskView />
				) : (
					<NoAssertionsRelated />
				)}
			</section>
		</StyledRelatedAssertions>
	);
}

export function NoAssertionsRelated() {
	return (
		<StyledNoAssertionsRelated className="StyledNoRisksRelated">
			{labels.noAssertionsRelatedToAccount}
		</StyledNoAssertionsRelated>
	);
}

const StyledNoAssertionsRelated = styled.section`
	display: flex;
	align-items: center;
	justify-content: flex-start;
	font-size: var(--px-14);
	font-weight: 300;
	line-height: var(--px-24);
	color: var(--neutrals-800);
`;

const StyledRelatedAssertions = styled.section`
	display: flex;
	align-items: center;
	width: 100%;
	.AssertionNameLabelWrapper {
		display: inline-flex;
		font-size: var(--px-14);
		font-weight: 400;
		line-height: var(--px-24);
		width: 92%;
		.assertion-item {
			width: 100%;
			justify-content: flex-start;
			.AssertionBadge {
				display: flex;
				align-items: center;
				width: 100%;
				.link-item {
					display: flex;
					width: 80%;
					font-size: var(--px-14);
					font-weight: 400;
					line-height: var(--px-24);
				}
			}
		}
		.AssertionsBadgeWrapper {
			display: flex;
			width: calc(100% - var(--px-500));
			align-items: center;
			.AssertionsNameChip {
				display: inline-flex;
				width: var(--px-40);
				min-width: var(--px-40);
				padding: 0 var(--px-10);
				justify-content: center;
				align-items: center;
				background: transparent;
				border: var(--px-1) solid var(--neutrals-700);
				border-radius: var(--px-4);
				.AssertionsNameChipTxt {
					font-size: var(--px-12);
					font-weight: 400;
					line-height: var(--px-16);
					color: var(--neutrals-700);
				}
			}
			.HigherRiskAssertionsNameChip {
				display: inline-flex;
				width: var(--px-40);
				min-width: var(--px-40);
				padding: 0 var(--px-10);
				justify-content: center;
				align-items: center;
				background: #b14891;
				border: var(--px-1) solid #b14891;
				border-radius: var(--px-4);
				.AssertionsNameChipTxt {
					font-size: var(--px-12);
					font-weight: 400;
					line-height: var(--px-16);
					color: #fff;
				}
			}
			.AssertionsNameLabel {
				display: inline-flex;
				margin-left: var(--px-10);
				font-size: var(--px-14);
				font-weight: 400;
				line-height: var(--px-24);
				color: var(--neutrals-700);
			}
			.pull-right {
				margin-left: var(--px-56);
			}
		}
	}
`;
